import { render, staticRenderFns } from "./infolist.vue?vue&type=template&id=67b81bc6&"
import script from "./infolist.vue?vue&type=script&lang=js&"
export * from "./infolist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports